import React, { Fragment } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import Price from "components/Price/Price"
import ProductCount from "components/Product/ProductCount"
import PropTypes from "prop-types"
import ProductRowCartAction from "components/Product/ProductRowCartAction"
import ListActions from "components/Product/ProductRowListAction"
import { Label, Icon } from "semantic-ui-react";
import shop from "shop/shop"
import OrderModel   from "shop/OrderModel";
import Responsive                                                from "react-responsive"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0
let articleOpen = 0		
console.log("PRODUCTS ROW: ", shop.cart.products)
const ProductRowDefault = observer( ( { product, onChange, list, cart, readOnly, available } ) => {
  let pageSize = 20
  let start = current
  current = current + pageSize
  /*shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
    .then( res => {
      console.log( "FROM API", { res } )
      orders = orders.concat( res.values.map( data => new OrderModel( data ) ) )
      openPositions = []
      // find orders with Open Positions
      let orderOpen = orders.filter( order => {
      return order.positions.filter( product => {
        let hasOpen = product.open && product.open !== 0
        if ( hasOpen ) {
        openPositions.push( product )
        console.log("PRODUCT: ",product)
        console.log("OPENPOSITIONS: ",openPositions)
        if(openPositions){
          if(openPositions.length > 0){
            for(let i = 0; openPositions.length > i;i++){
              if(openPositions[i].article_nr == product.article_nr){
                articleOpen = 1
              }
            }
          }
          
        }
        }
        return hasOpen
      } ).length
      } )
      
    } )
    console.log("HASOPEN:", openPositions)
    console.log("HASOPEN:", product.article_nr)
    let articleOpen = 0		
		if(openPositions){
			if(openPositions.length > 0){
				console.log("HASOPEN:", openPositions[0].article_nr)
				console.log("HASOPEN:", product.article_nr)
				for(let i = 0; openPositions.length > i;i++){
					if(openPositions[i].article_nr == product.article_nr){
						console.log("hasopenpassig")
						articleOpen = 1
					}
				}
			}
			
		}*/
  console.log("product", product, "articleOpen", articleOpen)
  if(available === true && product.extras && product.extras.stockColor && product.extras.stockColor.value.value !== "green"){
    return null
  }
  if(available === false && product.extras && product.extras.stockColor && product.extras.stockColor.value.value === "green"){
    return null
  }
  const hasCustomVE = product.extras.Z_Verpackungseinheit_Anzahl && product.extras.Z_Verpackungseinheit_Anzahl !== "1"
  
  return (<Fragment>
    <Responsive minWidth={790}>
    <tr>
      <td>
        {!readOnly && cart ? <ProductRowCartAction cart={cart} product={product}/> : null}
      </td>
      <td>
        <Link to={`/product/${product.map_id}`}>
          <strong>{product.article_nr}</strong> <br/>
          <span className="product-title">{product.title}</span>
        </Link>
      </td>
      <td><span className="f6 tl">{product.getNotice( "tiny" )}</span></td>

      <td className="tr">
        <div>{product.extras.veInhalt && product.extras.veInhalt.value.value ? product.extras.veInhalt.value.value : "1"} {translate("KE")} </div>
        <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
      </td>
            <td className="tr"><div className="tc">
        <Price>{product.price}</Price>
        <div className="flex flex-row">
          {/*product.pinfos.gc_rabatt && <div title={translate( "Coupon-Rabatt" )} className="mr1 pb2"><Label size="tiny" className={"giftcardPercent"} color="red"><span className="ttu">-{product.pinfos.gc_rabatt} %</span></Label></div>*/}
          {product.pinfos.gc_rabatt && <a title={translate( "Coupon-Rabatt" )} className="labelNeu1">&nbsp;&nbsp;{translate("Coupon:")} {product.pinfos.gc_rabatt} %&nbsp;&nbsp;</a>}
          {/*product.isSale && <div title={translate( "Ihr Kundenrabatt" )} className="pb2"><Label size="tiny" className={"salePercent"} color="red">-{product.salePercent}</Label></div>*/}
          {/*product.isSale && <a className="labelNeu">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>*/}
          {product.isSale && product.pinfos.sale_percent && <a className="labelNeu1">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
          {articleOpen == 1 && <a className="labelNeu">&nbsp;&nbsp;{translate("Rückstand")}&nbsp;&nbsp;</a>}
        </div></div>
      </td>
      {/*<td><Price>{product.price * product.unit_multi}</Price></td>*/}
      {/*<td></td>*/}
      <td>
        <div className="tr ">
          {!readOnly ? <div><Price>{product.price * product.count * product.unit_multi}</Price></div>  : product.count } 
        </div>
      </td>
          
          {<td className="tr">
            {!readOnly ? <ProductCount product={product} onChange={onChange}/> : <div className="fw7 tr"><Price>{product.price * product.count * product.unit_multi}</Price></div>}
          </td>}
      
      {list && <td>
        <div className="fr"><ListActions list={list} product={product}/></div>
      </td>}
    </tr>
    </Responsive>
            <Responsive maxWidth={789}>
        <tr className={`  step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="tl pt2 pb2">
          {/*            <Link to={`/product/${product.map_id}`}>
              <img style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
                className="pl2 db left"
                src={product.img_src_small || product.img_src || "/images/noimage.png"}
                alt=""/>
            </Link> */}
          </td>
            <td  className=" pr2  pt2 bb b--black-20 tr f6 v-center">
                      <Link to={`/product/${product.map_id}`}>
              <strong>{product.article_nr}</strong> &nbsp;
              <span className="product-title">{product.title}</span>
            </Link></td>
            <td>&nbsp;</td>
          </tr>
                    <tr className={` step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "Lieferbar:" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">            
            <span className="f6 tr">
              {typeof product.getNotice === "function" && product.getNotice("tiny")
                ? product.getNotice("tiny")
                : <span className={"black-40 f6"}><Icon title={"text"} name="truck" color={"green"}/></span>
              }
            </span></td>
          </tr>

          <tr className={` step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "KE pro VE" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">      
       
        {<div className="tr">{product.extras.veInhalt && product.extras.veInhalt.value.value ? product.extras.veInhalt.value.value : "1"} {translate("KE")} </div>}
        </td>
          </tr>
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <tr className={` step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "Brutto EK pro VE:" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">
          { product.pinfos && product.pinfos.brutto && <div className="tr "><span className="strike black-60"><Price>{product.pinfos.brutto}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{product.price}</Price></span></div>}
          { product.pinfos && !product.pinfos.brutto && <div className="tr "><Price>{product.price}</Price></div>}
          { !product.pinfos && <div className="tr "><Price>{product.price}</Price></div>}
          { !product.pinfos && <div className="tr "><Price>{product.price*product.unit_multi}</Price></div>}
          </td>
          </tr>}

         {/* <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "VE:" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">
            <div>{product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")} </div>
            <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
            </td>
          </tr> */}
{/*          <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "Menge:" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">
            <div>{product.count} </div>
            <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
            </td>
          </tr> */}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<tr className={`  step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{!readOnly ? translate( "Summe Brutto EK*" ) : translate( "Menge in (VE)" )} : </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">
              <div className="tr fw7">
                {!readOnly ? <div><Price>{product.price * product.count * product.unit_multi}</Price></div>  : product.count} 
              </div>
            </td>
          </tr>}
          <tr className={` ProductRowDefReturnMobileRight step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2 pt3 pb3 fw7 f5">{!readOnly ? translate( "Menge in VE" ) : translate( "Summe Brutto EK*" )}: </td>
            <td  className="pr2 pt1 pb1 bb b--black-20 tr f5">{!readOnly ? <ProductCount product={product} onChange={onChange}/> : <div className="fw7 tr"><Price>{product.price * product.count * product.unit_multi}</Price></div>}</td>
          </tr>
          {/*<tr className={`  ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="bb fw7 f5 ProductRowDefReturnMobileLeft">
            {translate( "UVP:" )}
            </td >
          <td className="tr b--black-20 bb ProductRowDefReturnMobileRight">
            <Price>{product.price * (product.count-1)}</Price>
            </td>
          </tr>*/}
        </Responsive>
        </Fragment>
  )
} )
export default ProductRowDefault

ProductRowDefault.propTypes = {
  index   : PropTypes.any,
  list    : PropTypes.object,
  cart    : PropTypes.object,
  onChange: PropTypes.func,
  product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Product/ProductRowDefault.js